import React from "react";
import { products } from "../mock/products";
import { slugify } from "./shared/Globals";
import FAQ from "./FAQ";
import { Helmet } from "react-helmet";

const Shop = () => {
  return (
    <>
      <Helmet>
        <title>{"Shop"}</title>
        <meta name="title" content={`${"Shop"}`} />
        <meta name="author" content="Eykam Wellness" />
        <meta
          property="og:description"
          content="India’s first Vitamin D chocolate from Eykam Wellness. Healthy. Delicious. Effective."
        />
        <link rel="canonical" href={`https://sunkisseddelight.com/products`} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="product" />
        <meta
          property="og:url"
          href={`https://sunkisseddelight.com/products`}
        />
        <meta property="og:title" content={`${"Shop"}`} />
        <meta
          property="og:description"
          content="India’s first Vitamin D chocolate from Eykam Wellness. Healthy. Delicious. Effective."
        />
      </Helmet>
      <div id="qodef-page-inner" className="qodef-content-full-width">
        <main
          id="qodef-page-content"
          className="qodef-grid qodef-layout--template"
        >
          <div className="qodef-grid-inner clear">
            <div className="qodef-grid-item qodef-page-content-section qodef-col--12">
              <div
                data-elementor-type="wp-page"
                data-elementor-id={9084}
                className="elementor elementor-9084"
                data-elementor-settings="[]"
              >
                <div className="elementor-inner">
                  <div className="elementor-section-wrap">
                    <section
                      className="elementor-section elementor-top-section elementor-element elementor-element-1dfbadef qodef-elementor-content-grid elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                      data-id="1dfbadef"
                      data-element_type="section"
                      data-settings='{"background_background":"classic"}'
                    >
                      <div className="elementor-container elementor-column-gap-default">
                        <div className="elementor-row">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4d8384e5"
                            data-id="4d8384e5"
                            data-element_type="column"
                          >
                            <div className="elementor-column-wrap elementor-element-populated">
                              <div className="elementor-widget-wrap">
                                <div
                                  className="elementor-element elementor-element-2e9f1722 elementor-widget-tablet__width-inherit elementor-widget elementor-widget-swissdelight_core_product_list"
                                  data-id="2e9f1722"
                                  data-element_type="widget"
                                  data-widget_type="swissdelight_core_product_list.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div
                                      className="qodef-shortcode qodef-m qodef-woo-shortcode qodef-woo-product-list qodef-item-layout--info-below qodef-button-position--bottom qodef-appear-animation--enabled qodef-hover--move qodef-grid qodef-layout--columns qodef-gutter--huge qodef-col-num--4 qodef-item-layout--info-below qodef--no-bottom-space qodef-pagination--off qodef-responsive--custom qodef-col-num--1440--4 qodef-col-num--1366--4 qodef-col-num--1024--2 qodef-col-num--768--2 qodef-col-num--680--1 qodef-col-num--480--1"
                                      data-options='{"plugin":"swissdelight_core","module":"plugins\/woocommerce\/shortcodes","shortcode":"product-list","post_type":"product","next_page":"2","max_pages_num":1,"behavior":"columns","images_proportion":"full","columns":"4","columns_responsive":"custom","columns_1440":"4","columns_1366":"4","columns_1024":"2","columns_768":"2","columns_680":"1","columns_480":"1","space":"huge","uneven_layout":"no","enable_line":"no","add_to_cart_position":"bottom","posts_per_page":"4","orderby":"date","order":"ASC","additional_params":"tax","tax":"product_cat","tax_slug":"Chocobar","product_list_enable_filter_order_by":"no","product_list_enable_filter_category":"no","layout":"info-below","title_tag":"h5","enable_excerpt":"yes","excerpt_length":"56","enable_category":"no","appear_animation":"yes","hover_animation":"move","pagination_type":"no-pagination","object_class_name":"SwissDelightCore_Product_List_Shortcode","taxonomy_filter":"product_cat","additional_query_args":{"tax_query":[{"taxonomy":"product_cat","field":"slug","terms":"Chocobar"}]},"space_value":40}'
                                    >
                                      <div className="qodef-filter-holder" />
                                      <div className="qodef-grid-inner clear">
                                        {products.map((p, i) => (
                                          <>
                                            <div className="qodef-e qodef-grid-item qodef-item--full product type-product post-4800 status-publish first instock product_cat-chocobar product_tag-cakes product_tag-tarts has-post-thumbnail shipping-taxable purchasable product-type-simple">
                                              <div className="qodef-woo-product-inner">
                                                <div className="qodef-woo-product-image">
                                                  <img
                                                    loading="lazy"
                                                    decoding="async"
                                                    width={800}
                                                    height={900}
                                                    src={p.img}
                                                    className="attachment-full size-full wp-post-image"
                                                    alt="f"
                                                    srcSet={p.img}
                                                    sizes="auto, (max-width: 800px) 100vw, 800px"
                                                  />
                                                </div>
                                                <div className="qodef-woo-product-content">
                                                  <h5
                                                    itemProp="name"
                                                    className="qodef-woo-product-title entry-title"
                                                  >
                                                    <a
                                                      itemProp="url"
                                                      className="qodef-woo-product-title-link"
                                                      href={
                                                        `SingleProduct/` +
                                                        `${p.id}`
                                                      }
                                                    >
                                                      {p.title}
                                                    </a>
                                                  </h5>
                                                  <p
                                                    itemProp="description"
                                                    className="qodef-woo-product-excerpt"
                                                  >
                                                    {p.header}
                                                  </p>
                                                  <div className="qodef-woo-product-price price">
                                                    <span className="woocommerce-Price-amount amount">
                                                      <h6
                                                        dangerouslySetInnerHTML={{
                                                          __html: p.price,
                                                        }}
                                                      ></h6>
                                                    </span>
                                                  </div>
                                                </div>
                                                <a
                                                  href={
                                                    `product/` +
                                                    p.id +
                                                    `/${slugify(p.title)}`
                                                  }
                                                  className="woocommerce-LoopProduct-link woocommerce-loop-product__link"
                                                >
                                                  {" "}
                                                </a>
                                              </div>
                                            </div>
                                          </>
                                        ))}
                                      </div>
                                      <svg
                                        className="qodef-m-pagination-spinner"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={512}
                                        height={512}
                                        viewBox="0 0 512 512"
                                      >
                                        <path d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <FAQ />
      </div>
    </>
  );
};

export default Shop;
